import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  activeTab: 1
}

export const systemConfiguration = createSlice({
  name: 'system-configuration',
  initialState,
  reducers: {
    setActiveTab: (state, action) => {
      state.activeTab = action.payload.activeTab
    }
  },
})

export const { setActiveTab } = systemConfiguration.actions

export default systemConfiguration.reducer
